export default __webpack_public_path__ + "static/media/wadapp4-min.c1275dea.png";